const IncomingManualPaymentsGrid = () => import(/* webpackChunkName: "IncomingManualPaymentsGrid" */ './containers/IncomingManualPaymentsGrid');
const TransactionsHistory = () => import(/* webpackChunkName: "TransactionsHistory" */ './containers/TransactionsHistory');
const WalletHistory = () => import(/* webpackChunkName: "WalletHistory" */ './containers/WalletHistory');
const Withdrawals = () => import(/* webpackChunkName: "WalletHistory" */ './containers/WithdrawalGrid');

export const transactionsRouting = [
    {path: '/finance/incoming-manual-payments', name: 'incoming-manual-payments', component: IncomingManualPaymentsGrid},
    {path: '/finance/history', name: 'transactions-history', component: TransactionsHistory},
    {path: '/finance/wallet-history', name: 'wallet-history', component: WalletHistory},
    {path: '/finance/withdrawals', name: 'withdrawals', component: Withdrawals},
]
